import {Component} from '@angular/core';
import {AppInitService} from '../../core/services/app-init.service';
import {ActivatedRoute, Router} from '@angular/router';
import {storageKey} from "../../api/enum/storage.constants";
import {SessionStorageService} from "../../core/services/session-storage.service";
import {AesService} from "../../core/services/aes.service";

@Component({
    selector: 'app-init',
    imports: [],
    templateUrl: './init.component.html',
    styleUrl: './init.component.scss'
})
export class InitComponent {
    constructor(
        private initService: AppInitService,
        private router: Router,
        private route: ActivatedRoute,
        private aesService: AesService,
        private storage: SessionStorageService
    ) {
    }
    // localhost:4200?token=1dbae3b5f25fa9dc6ab10389b7273f15df6242f3c5a0414b43c6921958deb139421d71ee386f2910fab6739ae4d7679f56930d6c557a952404831d373f0c9122

    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            const token = params['token'];
            if (token) {
                const decoded_token = this.aesService.decrypt(token)
                this.storage.set(storageKey.applicationNumber, decoded_token.admission_application_number)

                this.initService.init().subscribe(() => {
                    this.router.navigateByUrl('/landing');
                });
            } else {
                this.router.navigateByUrl('/not-found');
            }
        });
    }
}
